"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyleUpdateAfterToggleTransition = void 0;
var react_1 = require("react");
var useStyleUpdateAfterToggleTransition = function (_a) {
    var styleOptions = _a.styleOptions, // ['hidden', 'visible']
    _initStyle = _a.initStyle, //hidden
    toggleState = _a.toggleState, //isExpanded
    transitionDuration = _a.transitionDuration //300
    ;
    var initStyle = (0, react_1.useRef)(_initStyle);
    //helps to make the accordionOverflow visible once its open,
    //for scenarios where a data viz tooltip needs to stick out
    var _b = (0, react_1.useState)(initStyle.current), style = _b[0], setStyle = _b[1];
    (0, react_1.useEffect)(function () {
        var timeoutId;
        if (toggleState) {
            // Set timeout for making content visible after animation
            timeoutId = setTimeout(function () {
                // Double check if still expanded before setting to visible
                if (toggleState) {
                    setStyle(styleOptions.find(function (op) { return op !== initStyle.current; }));
                }
            }, transitionDuration);
        }
        else {
            // Immediately set to hidden when closing
            setStyle(initStyle.current);
        }
        // Cleanup function to clear timeout if component updates/unmounts
        return function () {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [toggleState, transitionDuration]);
    return ({
        style: style
    });
};
exports.useStyleUpdateAfterToggleTransition = useStyleUpdateAfterToggleTransition;
